import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatOption, MatSelect } from '@angular/material/select';
import { Subscription } from 'rxjs/internal/Subscription';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'neoris-modal-pause-alert',
  templateUrl: './modal-pause-alert.component.html',
  styleUrl: './modal-pause-alert.component.css'
})
export class ModalPauseAlertComponent implements OnInit  {
  numbers: number[] = Array.from({ length: 24 }, (_, i) => i + 1);
  alertsEnabled:boolean = false;
  formStopAlert:UntypedFormGroup = new UntypedFormGroup({})
  request:any={}
  arrayIncidentsTypes:any[] = []
  strTranslate:string
  private onLanChange:Subscription

  form: FormGroup;
  @ViewChild('toTimeInput') toTimeInput: ElementRef;

  filters = new UntypedFormGroup({
    incidentType: new UntypedFormControl([],Validators.required)
    
  });
  

  @ViewChild('selIncidentType') selIncidentType: MatSelect;

  constructor (public dialogRef: MatDialogRef<ModalPauseAlertComponent>,
    private controltowerservice:ControltowerService,
    private fb: UntypedFormBuilder,
    private _snackBar:MatSnackBar,
    private translate: TranslateService
  ) {

    this.formStopAlert = this.fb.group({
    
      
      options:  ( ['1', [Validators.required]]),
      from: ( ['', [Validators.required]]),
      to: ( ['', [Validators.required]]),
      time: ( ['', [Validators.required]]),

    
    
  
    });


  }

  get incidentType(){
    return this.filters.controls
  }

  
  


 async ngOnInit(): Promise<void>  {
 

    
    this.onLanChange = this.translate.onLangChange.subscribe(s => {
      console.log("idioma",s.lang)
      this.strTranslate = s.lang != undefined ? s.lang : "en";
    
      let SubjectIncidentsTypes = this.getIncidentsTypes()
    })

    console.log('ssss',this.strTranslate)
    if(this.strTranslate == undefined){
      this.strTranslate = 'en'
   
    let SubjectIncidentsTypes = this.getIncidentsTypes()
    }

    
   
  }


    toggleAllSelection(matSelect: MatSelect) {
      const isSelected: boolean = matSelect.options
        // The "Select All" item has the value 0, so find that one
        .filter((item: MatOption) => item.value === 0)
        // Get the value of the property 'selected' (this tells us whether "Select All" is selected or not)
        .map((item: MatOption) => item.selected)
        // Get the first element (there should only be 1 option with the value 0 in the select)
        [0];
  
      if (isSelected) {
        matSelect.options.forEach((item: MatOption) => item.select());
      } else {
        matSelect.options.forEach((item: MatOption) => item.deselect());
      }
      
      console.log('valor de matSelect:',matSelect)
  }


  openSnackBar(message: string, action: string) {
    if(action == 'OK'){
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar']
    });
  }
  else{
    this._snackBar.open(message, action, {
      duration: 5000,
      panelClass: ['blue-snackbar-false']
    });
  }
  }

  addHours(date: Date, hours: number): Date {
    const newDate = new Date(date);
    newDate.setHours(newDate.getHours() + hours);
    return newDate;
  }
  

  async SaveFormStopAlert(){
    console.log('option selected', this.formStopAlert.value.options)
    let datetime = new Date();

    let incidentType = this.filters.get('incidentType').value  


    console.log('select inciden type----->',incidentType)
    const date = this.formStopAlert.value.to
    const time = this.formStopAlert.value.time

    if (date && time) {
      /*const [hours, minutes] = time.split(':');
      const datetime = new Date(date);
      datetime.setHours(hours, minutes);
      */
      datetime = this.addHours(date,time)
      console.log('Selected datetime:', datetime);
      
    }

    if(incidentType == null || incidentType == undefined || incidentType.length == 0){
      this.openSnackBar(this.translate.instant('STOP_ALERT_EVENT'),"FAILED")
      return
    }

    if(this.formStopAlert.value.options == "1"){ //ALL DAY, insert null
      
      


      this.request.PausedTo = null
    }
    else{
      console.log('to',this.formStopAlert.value.to )
      this.request.PausedTo = datetime

      console.log("valor fecha",this.formStopAlert.value.to)
      console.log("valor tiempo",this.formStopAlert.value.time)

      
      if(this.formStopAlert.value.time == null || this.formStopAlert.value.time == undefined || this.formStopAlert.value.time == ""){
        this.openSnackBar(this.translate.instant('TIME_SELECT'),"FAILED")
        return
      }

    
    }
      
      this.request.SourceDeviceId = Number(localStorage.getItem('sourceDeviceId'))
      this.request.incidentTypes = incidentType
      
      console.log("request enviado",this.request)
      let exito = await this.SaveStopAlert(this.request)

      if(exito){
        this.openSnackBar(this.translate.instant('ALERT_SUCCESS'),"OK")
        this.dialogRef.close()
      }
      else{
        this.openSnackBar(this.translate.instant('ALERT_FAILED'),"FAILED")
      }
   


  }


  close(){
    this.alertsEnabled = true;
    this.dialogRef.close()
  }


  private async SaveStopAlert(request:any): Promise<any> {
    
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.saveStopAlert(request).subscribe(
        {
          next: (report: any) => {
            console.log('respondio el save reporte--->:',report);
                                  
            resolve(report);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  openTimePicker(): void {
    this.toTimeInput.nativeElement.focus();
    this.toTimeInput.nativeElement.click();
  }


  private async getIncidentsTypes(): Promise<boolean> {


    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getIncidentsTypes(this.strTranslate).subscribe(
        {

          next: (incidentype: any) => {
              this.arrayIncidentsTypes = incidentype
              console.log('obtener values select--->',incidentype)
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }



}
